import { AxiosRequestConfig } from 'axios';
import { EventSource } from 'eventsource';

import { getAccessTokenFromCookie } from './auth';

export function axiosOptions(timeout?: number): AxiosRequestConfig {
  const token = getAccessTokenFromCookie();
  return { validateStatus: null, headers: { Authorization: `Bearer ${token}` }, timeout };
}

export function blobAxiosOptions(): AxiosRequestConfig {
  const token = getAccessTokenFromCookie();
  return { responseType: 'blob', validateStatus: null, headers: { Authorization: `Bearer ${token}` } };
}

export function initEventSourceEndpoint(url: string): EventSource {
  const token = getAccessTokenFromCookie();

  const es = new EventSource(url, {
    fetch: (input, init) =>
      fetch(input, {
        ...init,
        headers: {
          ...init?.headers,
          Authorization: `Bearer ${token}`,
        },
      }),
  });

  es.onerror = (error) => {
    const { code, message } = error;
    if (es.readyState !== EventSource.CLOSED) {
      if (code === 401 || code === 403) {
        console.error('SSE request not authorized', message);
      } else {
        console.error('SSE request error', message);
      }
    }
  };
  return es;
}
